import { ItemDetail } from '../ItemDetail/ItemDetail'


export const ItemDetailContainer = () => {
    return (
        <>    
            <div className="container mt-2">
                <div className="row">
                    <ItemDetail />  
                </div>
            </div>
        </>
    )
}
